import React from 'react';
import PropTypes from 'prop-types';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { shellTips } from '@bingads-webui-campaign-react/shell-ui-common';

export const WithAdGroupRepository = ({
  campaignLoadFallback, WrappedComponent, i18n, ...passThroughProps
}) => (
  <CampaignOData
    call={
      ({ currentAdGroup }) => currentAdGroup.get({
        // finally this would become $expand=Campaign&$select=Id,Name,EntityStatus,SearchBid,BiddingSchema,DisplayBiddingStrategyType,Medium
        select: ['Id', 'Name', 'EntityStatus', 'SearchBid', 'CpvBid', 'CpmBid', 'CpcBid', 'BiddingScheme', 'DisplayBiddingStrategyType', 'Medium', 'UseOptimizedTargeting', 'DealMinimumBid'],
      })
    }
    escapeHatch={({ currentAdGroup }) => (currentAdGroup ? undefined : null)}
    fallback={campaignLoadFallback}
    onError={() => {
      notificationApi.showWarning(i18n.getString(shellTips.shellDataError));
      return campaignLoadFallback;
    }}
  >
    {adGroupFromOData =>
      (<WrappedComponent {...passThroughProps} adGroupFromOData={adGroupFromOData} />)}
  </CampaignOData>
);

WithAdGroupRepository.propTypes = {
  campaignLoadFallback: PropTypes.element.isRequired,
  WrappedComponent: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
